import { createSpeech, getPaymentUrl, getSpeech } from './functions';
import { CreateSpeechRequest, GetPaymentUrlRequest, GetSpeechRequest } from '@packages/types';

export class FirebaseClient {
  async createSpeech(data: CreateSpeechRequest) {
    return createSpeech(data);
  }

  async getSpeech(data: GetSpeechRequest) {
    return getSpeech(data);
  }

  async getPaymentUrl(data: GetPaymentUrlRequest) {
    return getPaymentUrl(data);
  }
}
